import { initContract } from "@ts-rest/core";
import {
	CreatedTimeAway,
	CreatedTimeAwayList,
	createLeave,
	createTimeAwayAdjustmentInput,
	deleteLeave,
	finalizeTimeAwayInput,
	findTimeAwayFilter,
	PaginatedCreatedTimeAwaysDto,
	PaginatedTimeAwayHistoryDto,
	queryLeaveHistory,
	TotaluserTimeAwayCredits,
} from "../validators/leave.validator";
import {
	findAllTimeAwayFilter,
	ManyUsersGroupedLeaves,
} from "../validators/grouped-leaves.dto";
import { z } from "zod";

const c = initContract();

export const userLeaveContract = c.router({
	getLeaveCredit: {
		method: "GET",
		path: "/users/:userId/leave-credits",
		responses: {
			200: c.type<TotaluserTimeAwayCredits>(),
		},
	},
	getUserLeaves: {
		method: "GET",
		path: "/users/:userId/leaves",
		responses: {
			200: c.type<PaginatedCreatedTimeAwaysDto>(),
		},
		query: findTimeAwayFilter,
	},
	getUserLeaveCredit: {
		method: "GET",
		path: "/users/:userId/leaves-credits",
		responses: {
			200: c.type<PaginatedCreatedTimeAwaysDto>(),
		},
		query: findTimeAwayFilter,
	},
	addUserLeaves: {
		method: "POST",
		path: "/users/:userId/leaves",
		body: createLeave,
		responses: {
			200: c.type<CreatedTimeAwayList>(),
		},
	},
	updateUserLeaves: {
		method: "PUT",
		path: "/users/:userId/leaves/:timeAwayId",
		body: createLeave,
		responses: {
			200: c.type<CreatedTimeAwayList>(),
		},
	},
	deleteUserLeaves: {
		method: "DELETE",
		path: "/users/:userId/leaves/:timeAwayId",
		body: deleteLeave,
		responses: {
			204: c.type<void>(),
		},
	},
	getLeaveHistory: {
		method: "GET",
		path: "/users/:userId/leave-history",
		query: queryLeaveHistory,
		responses: {
			200: c.type<PaginatedTimeAwayHistoryDto>(),
		},
	},

	getLeaveOverview: {
		method: "GET",
		path: "/leaves/overview",
		query: findAllTimeAwayFilter,
		responses: {
			200: c.type<ManyUsersGroupedLeaves>(),
		},
	},
	adjustLeaveCredit: {
		method: "POST",
		path: "/leave-credits",
		body: createTimeAwayAdjustmentInput,
		responses: {
			204: c.type<void>(),
		},
	},
	finalizeTimeaway: {
		method: "PUT",
		path: "/leaves/:timeAwayId/approve",
		body: finalizeTimeAwayInput,
		responses: {
			200: c.type<CreatedTimeAway>(),
		},
	},
	exportAttendance: {
		method: "POST",
		path: "/attendances/export",
		body: z.void(),
		responses: {
			201: c.type<any>(),
		},
		query: z.object({
			startDate: z.string().datetime(),
			endDate: z.string().datetime(),
			format: z.string(),
		}),
	},
});
